interface SVGProps {
  color: string;
  style: React.CSSProperties;
}

const SVG = ({ color, style }: SVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="47"
    height="52"
    viewBox="0 0 47 52"
    fill="none"
  >
    <path
      d="M41.6266 1C43.4104 1 44.85 2.45003 44.85 4.22345V29.938C44.85 31.7219 43.4 33.1615 41.6266 33.1615H4.74987C2.96602 33.1615 1.52642 31.7115 1.52642 29.938V4.22345C1.51599 2.4396 2.96602 1 4.74987 1C5.98083 1 42.7532 1 41.6266 1Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.1357 33.1719L10.1641 38.1479H23.183H36.2125L34.2408 33.1719"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M41.4074 41.9238L45.1733 48.7254C45.7366 49.7477 44.9959 50.9996 43.8276 50.9996H2.53819C1.36982 50.9996 0.629156 49.7477 1.19248 48.7254L4.95839 41.9238H41.3969H41.4074Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.1826 1.10449V15.7613C23.1826 16.4915 23.8711 17.0757 24.7161 17.0757H44.2341"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M15.6098 5.11035H9.36115C8.81382 5.11035 8.37012 5.55405 8.37012 6.10138V12.3918C8.37012 12.9391 8.81382 13.3828 9.36115 13.3828H15.6098C16.1572 13.3828 16.6009 12.9391 16.6009 12.3918V6.10138C16.6009 5.55405 16.1572 5.11035 15.6098 5.11035Z"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M36.9741 5.11035H30.7254C30.1781 5.11035 29.7344 5.55405 29.7344 6.10138V12.3918C29.7344 12.9391 30.1781 13.3828 30.7254 13.3828H36.9741C37.5214 13.3828 37.9651 12.9391 37.9651 12.3918V6.10138C37.9651 5.55405 37.5214 5.11035 36.9741 5.11035Z"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M36.9741 20.7686H30.7254C30.1781 20.7686 29.7344 21.2123 29.7344 21.7596V28.05C29.7344 28.5973 30.1781 29.041 30.7254 29.041H36.9741C37.5214 29.041 37.9651 28.5973 37.9651 28.05V21.7596C37.9651 21.2123 37.5214 20.7686 36.9741 20.7686Z"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M15.6098 20.7686H9.36115C8.81382 20.7686 8.37012 21.2123 8.37012 21.7596V28.05C8.37012 28.5973 8.81382 29.041 9.36115 29.041H15.6098C16.1572 29.041 16.6009 28.5973 16.6009 28.05V21.7596C16.6009 21.2123 16.1572 20.7686 15.6098 20.7686Z"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </svg>
);

export default SVG;
